import { render, staticRenderFns } from "./AssessmentExamCard.vue?vue&type=template&id=2bc260c2&scoped=true"
import script from "./AssessmentExamCard.vue?vue&type=script&lang=js"
export * from "./AssessmentExamCard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentExamCard.vue?vue&type=style&index=0&id=2bc260c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc260c2",
  null
  
)

export default component.exports